import React, { FC } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';

interface NumberTextProps {
  num: string;
  title: string;
  text: string;
}

const NumberText: FC<NumberTextProps> = (props) => {
  const { num, text, title } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root}>
      <div className={styles.num}>{num}</div>
      <div className={styles.text}>
        <span>{title}</span> {text}
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    padding: 42px 32px;
    background: #f6f8f9;
    border-radius: 12px;
  `,
  num: css`
    font-weight: 600;
    font-size: 82px;
    line-height: 130%;
    color: rgba(110, 124, 135, 0.6);
  `,
  text: css`
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #252c32;
    span {
      font-weight: 600;
    }
  `,
});

export default NumberText;
